import clsx from "clsx";
import React from "react";

interface SpeakersInfoBlockProps {
  className?: string;
  infoBlock: {
    title: string;
    description: string;
    icon: string;
    descriptionClassName?: string;
  }[];
}

export const SpeakersInfoBlock = ({
  className,
  infoBlock,
}: SpeakersInfoBlockProps): JSX.Element => {
  return (
    <div
      className={clsx("grid md:flex-col gap-6 lg:gap-8 4xl:gap-10", className)}
    >
      {infoBlock.map((item, index) => (
        <div
          className="flex flex-col gap-[10px] text-fluid--xs !leading-[125%]"
          key={index}
        >
          <div className="flex gap-[8px]">
            <span>{item.icon}</span> <p className="font-bold">{item.title}</p>
          </div>
          <p className={clsx("font-extralight", item.descriptionClassName)}>
            {item.description}
          </p>
        </div>
      ))}
    </div>
  );
};
